import {
	Drawer,
	DrawerBody,
	DrawerContent,
	DrawerHeader,
	DrawerOverlay,
	Flex,
	Spinner,
} from "@chakra-ui/react";
import { setAwardedSupplier } from "actions/RFQ/rfqsAction";
import { DateInput } from "components/DateInput";
import { Button } from "components/RFQ/Button";
import { FileUpload } from "components/RFQ/FileUpload";
import { FieldForm } from "components/RFQ/Input";
import { Form, Formik } from "formik";
import React from "react";
import * as yup from "yup";
import { VStack } from "@chakra-ui/react";
import { useSelector } from "react-redux";
import { CloseButton } from "components/RFQ/CloseButton";
import EmailPreview from "pages/EmailPreview/EmailPreview";

const validationSchemaAward = yup.object().shape({
	company: yup.string().required("Required"),
	rfq: yup.string().required("Required"),
	message: yup
		.string()
		.required("Required")
		.min(1)
		.matches(/\S/, "Required")
		.strict(),
	file: yup
		.mixed()
		.nullable()
		.test("is-string-or-file", "Must be a file", (value) => {
			if (!value) return true;
			return typeof value === "string" || value?.[0] instanceof File;
		}),
});

const validationSchemaAwardGuest = yup.object().shape({
	rfq: yup.string().required("Required"),
	message: yup
		.string()
		.required("Required")
		.min(1)
		.matches(/\S/, "Required")
		.strict(),
	file: yup
		.mixed()
		.nullable()
		.test("is-string-or-file", "Must be a file", (value) => {
			if (!value) return true;
			return typeof value === "string" || value?.[0] instanceof File;
		}),
});
const validationSchemaDeclineGuest = yup.object().shape({
	rfq: yup.string().required("Required"),
	message: yup.string().required("Required"),
});
const validationSchemaDecline = yup.object().shape({
	company: yup.string().required("Required"),
	rfq: yup.string().required("Required"),
	message: yup.string().required("Required"),
});

export const AwardDeclineSupplierDrawer = ({
	isOpen,
	company,
	onClose,
	rfq,
	typeModal,
	setLoadRFQData,
	refreshData,
	guestName,
	guestEmail,
	isSubmissionPreview,
}) => {
	const [formValues, setFormValues] = React.useState(null);

	const companyId = typeModal?.companyId;
	const supplierInvitedList = rfq?.supplierInvited?.all || [];
	const listExcludeAwards = [
		"unsuccessful",
		"decline",
		"awarded",
		"invited",
		"inprogress",
	];

	let filterInvitedList = supplierInvitedList.filter((f) => {
		return !listExcludeAwards.includes(f?.status?.toLowerCase());
	});

	const currentCompany = useSelector((state) => state?.auth?.current_company);

	const projectsOptions = company
		? [{ value: company?.id, label: company?.name }]
		: filterInvitedList?.map((company, index) => ({
				value: company?.company?.id
					? company?.company?.id
					: filterInvitedList[index]?.email,
				label: company?.company?.name
					? company?.company?.name
					: filterInvitedList[index]?.name,
			}));

	const initialValuesFeedback = {
		rfq: `${rfq?.project?.name} ${rfq?.supplierList?.name ? `| ${rfq?.supplierList?.name}` : ""}`,
		company: guestEmail || parseInt(companyId) || "",
		message: "",
		status: 1,
		file: null,
	};

	const initialValuesDecline = {
		rfq: `${rfq?.project?.name} ${rfq?.supplierList?.name ? `| ${rfq?.supplierList?.name}` : ""}`,
		status: 0,
		company: parseInt(companyId) || "",
		reason: "",
		message: "",
	};

	let initialValues = null;
	let validationSchema = null;
	switch (typeModal.type) {
		case "award":
			initialValues = initialValuesFeedback;
			validationSchema =
				guestName !== undefined
					? validationSchemaAwardGuest
					: validationSchemaAward;
			break;

		case "decline":
			initialValues = initialValuesDecline;
			validationSchema =
				guestName !== undefined
					? validationSchemaDeclineGuest
					: validationSchemaDecline;
			break;
		default:
			initialValues = initialValuesFeedback;
			validationSchema = validationSchemaAward;
			break;
	}

	let content = {};
	switch (typeModal.type) {
		case "award":
			content = {
				title: "Award this supplier",
				icon: "check-circle",
				iconColor: "text-royal-blue bg-soft-blue",
				description:
					"Congratulations on your selection. Please notify the chosen bidder using the message box below.",
				selectionLabel: "Company name",
				name: "company",
				typeField: "select",
				messageLabel: "Message",
				options: projectsOptions,
				hint: "This is a hint text to help user.",
				isFileUpload: true,
				isDisabled: true,
			};
			break;
		case "decline":
			content = {
				title: "Decline this supplier",
				icon: "x-square",
				iconColor: "bg-utility-warning-secondary text-fg-warning",
				description:
					"Please notify the declined bidder using the message box below.",
				selectionLabel: "Company name",
				name: "company",
				typeField: "select",
				messageLabel: "Message",
				options: projectsOptions,
				hint: "This is a hint text to help user.",
				isFileUpload: false,
				isDisabled: true,
			};
			break;
		default:
			content = {};
			break;
	}

	const handleRFQActionSubmit = async (values) => {
		try {
			!isSubmissionPreview && setLoadRFQData(true);
			if (typeModal.type === "decline") {
				handleDeclineSubmit(values);
			} else if (typeModal.type === "award") {
				handleAwardSubmit(values);
			}
		} catch (error) {
			console.log("error", error);
		}
		!isSubmissionPreview && setLoadRFQData(false);
	};

	const handleDeclineSubmit = async (values) => {
		try {
			!isSubmissionPreview && setLoadRFQData(true);
			let res = await setAwardedSupplier(rfq?.id, values);
			refreshData();
			if (res) {
				onClose();
			}
		} catch (error) {
			console.log("error", error);
		}
		!isSubmissionPreview && setLoadRFQData(false);
	};

	const handleAwardSubmit = async (values) => {
		try {
			!isSubmissionPreview && setLoadRFQData(true);
			values.email = guestEmail;
			let res = await setAwardedSupplier(rfq?.id, values);
			refreshData();
			if (res) {
				onClose();
			}
		} catch (error) {
			console.log("error", error);
		}
		!isSubmissionPreview && setLoadRFQData(false);
	};

	return (
		<>
			<Drawer
				placement={"right"}
				isOpen={isOpen}
				onClose={onClose}
				size="xl"
				className="bg-white p-11"
			>
				<DrawerOverlay onClick={onClose} />
				<DrawerContent maxWidth={"1280px"}>
					<DrawerHeader>
						<Flex
							justifyContent="space-between"
							align={"center"}
						>
							<div>
								<p className="text-xl font-semibold text-primary-900">
									{typeModal.type === "award"
										? "Award Supplier"
										: "Decline Supplier"}
								</p>
							</div>
							<CloseButton onClose={onClose} />
						</Flex>
					</DrawerHeader>
					<DrawerBody>
						<div className="grid grid-cols-3">
							<div>
								<AwardDeclineForm
									initialValues={initialValues}
									validationSchema={validationSchema}
									handleRFQActionSubmit={handleRFQActionSubmit}
									content={content}
									guestName={guestName}
									onClose={onClose}
									setFormValues={setFormValues}
									companyId={companyId}
								/>
							</div>
							<div className="col-span-2">
								<p className="px-11 text-lg font-semibold text-primary-900">
									{typeModal.type === "award"
										? "Award Supplier Email Preview"
										: "Decline Supplier Email Preview"}
								</p>
								<EmailPreview
									companyName={
										guestName ||
										(formValues?.company
											? projectsOptions.find(
													(opt) => opt.value === formValues.company
												)?.label
											: company?.name)
									}
									rfqTitle={rfq?.name}
									projectTitle={rfq?.project?.name}
									emailType={
										typeModal.type === "award"
											? "supplierAwarded"
											: "supplierDeclined"
									}
									additionalMessage={formValues?.message}
									currentCompanyName={currentCompany?.name}
									attachment={formValues?.file}
								/>
							</div>
						</div>
					</DrawerBody>
				</DrawerContent>
			</Drawer>
		</>
	);
};

const AwardDeclineForm = ({
	initialValues,
	validationSchema,
	handleRFQActionSubmit,
	content,
	guestName,
	onClose,
	companyId,
	setFormValues,
}) => {
	return (
		<Formik
			initialValues={initialValues}
			onSubmit={handleRFQActionSubmit}
			validationSchema={validationSchema}
			validateOnMount
			enableReinitialize
		>
			{({ isSubmitting, isValid, dirty, setFieldValue, values }) => {
				setFormValues(values);
				return (
					<Form>
						<VStack
							id="award-supplier-modal-body"
							spacing={6}
							align="stretch"
						>
							<FieldForm
								label="RFx"
								name="rfq"
								type="text"
								disabled={true}
								icon="file-attachment-04"
								className={"text-primary-500"}
							/>
							{content.typeField === "date" ? (
								<DateInput
									icon={true}
									label={content.selectionLabel}
									name="date"
									className="mb-1"
								/>
							) : (
								<>
									{content.selectionLabel === "Company name" ? (
										<>
											{!guestName ? (
												<FieldForm
													label={content.selectionLabel}
													name={content.name}
													type="select"
													value={values.company}
													options={content.options}
													isDisabled={companyId ? true : false}
												/>
											) : (
												<>
													<FieldForm
														label={content.selectionLabel}
														name={content.name}
														type="select"
														value={guestName}
														options={[
															{
																value: guestName,
																label: guestName,
															},
														]}
														isDisabled={true}
													/>
												</>
											)}
										</>
									) : (
										<>
											<FieldForm
												label={content.selectionLabel}
												name={content.name}
												type="select"
												options={content.options}
												isDisabled={companyId ? true : false}
											/>
										</>
									)}
								</>
							)}
							<FieldForm
								type="textArea"
								label={content.messageLabel}
								name="message"
								placeholder="Enter a description..."
								maxLength={500}
							/>
							{content.isFileUpload && (
								<FileUpload
									type="file"
									name="file"
									className="my-4 w-full"
									types={["pdf", "docx", "xlsx", "jpeg", "jpg"]}
									defaultFileName="Document"
									isDisabled={true}
									maxFileSize={50}
								/>
							)}
							<Flex
								gap={3}
								className="!w-full"
							>
								<Button
									btntype={"base"}
									style={{ width: "100%" }}
									onClick={onClose}
									type="button"
								>
									Cancel
								</Button>
								<Button
									style={{ width: "100%" }}
									disabled={!isValid}
								>
									{isSubmitting ? <Spinner></Spinner> : "Send"}
								</Button>
							</Flex>
						</VStack>
					</Form>
				);
			}}
		</Formik>
	);
};
